<template>
  <a name="sustainability"></a>
  <div class="hero-container">
    <!-- Camada de fundo com a imagem e efeito parallax -->
    <div class="hero-background"></div>

    <!-- Camada de sobreposição preta com 50% de transparência -->
    <div class="overlay"></div>

    <!-- Conteúdo do programa -->
    <div class="hero-content">
      <div class="row"> <!-- Ajuste aqui para centralizar o conteúdo -->
        <div class="col-12">
          <h1 class="tks">thank you</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {


  components: {
  },

  data() {
    return {};
  }
};
</script>

<style scoped>
 :root {
   --cream: #E0D0A6;
   --blue: #6FD0E7;
   --blue2: #010202;
   --green: #536D3F;
   --mid-green: #475C37;
   --dark-green: #3D4D31;
   --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
 }


 .tks {
  font-family: 'Gaze Pro';
  font-size: 15rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
  color: rgba(224, 208, 166, 0.7); 
}

.tks-verde {
  font-family: 'Gaze Pro';
  font-size: 15rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
  color: rgba(83, 109, 63, 0.9); 
}

.tks-amarelo {
  font-family: 'Gaze Pro';
  font-size: 15rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
  color: rgba(224, 208, 166, 0.7); 
}


.inputx {
  font-family: MinhaFonte;
  background-color: transparent;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 1px solid #e0d0a6;
  font-size: 2rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
  margin-bottom: 0.4rem;
  width: 50%;
}

.inputx::placeholder {
  color: #e0d0a6;
  opacity: 0.25;
}

.btemail {
  font-family: 'Object Sans';
  color: var(--cream);
  padding: 10px 10px 3px 10px;
  margin-left: 10px;
  border: 1px solid #e0d0a6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 0.28rem;
  line-height: 1.9rem;
  background-color: transparent;
}

.btemail:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}




/* Estilo para a camada de fundo com a cor verde escuro e efeito parallax */
.hero-container {
  position: relative;
  width: 100%;
  min-height: 500px; /* Define a altura mínima como 500px */
  height: auto; /* Permite que o conteúdo expanda a altura conforme necessário */
  overflow: hidden; /* Impede que o conteúdo saia da tela */
}

.hero-background {
  position: absolute; /* Altera para absolute para ficar contido na seção */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* Garante que o fundo ocupe o tamanho da seção */
  background-color: #3D4D31; /* Cor verde escuro */
  z-index: -2; /* Coloca o fundo atrás da camada preta e do conteúdo */
  background: url('@/assets/foto4.jpg') no-repeat center center/cover;
  background-attachment: fixed; /* Efeito parallax */
  background-size: cover; /* Garantir que a imagem cubra toda a área */
}

/* Camada preta com 50% de transparência */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(83, 109, 63, 0.2); /* 50% de transparência */
  z-index: -1; /* Coloca a camada preta acima do fundo, mas abaixo do conteúdo */
}

/* Estilos de conteúdo */
.hero-content {
  position: relative;
  z-index: 2; /* Coloca o conteúdo acima do fundo e da camada preta */
  padding: 1rem;
  margin-left: 1rem;
  color: white;
}

.amarelo {
  color: var(--cream);
}

.azul {
  color: var(--blue);
}

/* Estilos para texto */
.f-4 {
  font-size: 2.2rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
  margin-bottom: 0.4rem;
}

.f-5 {
  font-size: 2.1rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
}

.border-esq {
  border-left: 2px solid var(--cream);
  padding: 4rem;
  text-align: left;
}

.row {
  margin: 3rem 5%;
  padding: 2rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.row.justify-center {
  display: flex;
  justify-content: center; /* Centraliza horizontalmente o conteúdo */
}

.row.align-center {
  align-items: center; /* Centraliza verticalmente o conteúdo */
}

.col-12 {
  display: flex;
}

h1 {
  font-family: var(--object-sans);
  font-size: 5rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
}

/* Ajuste para telas pequenas (mobile) */
@media (max-width: 640px) {

.tks {
  font-family: 'Gaze Pro';
  font-size: 15rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
  color: rgba(224, 208, 166, 0.7); 
  text-align: center;
}


  .f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  .f-5 {
    font-size: 1.25em;
    letter-spacing: 0.06rem;
    line-height: 3.2rem;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    padding: 0rem;
    margin-left: 0rem;
    color: white;
  }

  h1 {
    font-family: var(--object-sans);
    font-size: 4rem;
    font-weight: 400;
    letter-spacing: 0.06rem;
  }

  .row {
    flex-direction: column;
  }

  .col-4 {
    flex: 0 0 100%;
    margin-bottom: 5rem;
    padding-left: 1rem;
  }

  .border-esq {
    border-left: 0;
  }
}
</style>
